import { render } from "./AddColis.vue?vue&type=template&id=5dfede0f&scoped=true&ts=true"
import script from "./AddColis.vue?vue&type=script&lang=ts"
export * from "./AddColis.vue?vue&type=script&lang=ts"

import "./AddColis.vue?vue&type=style&index=0&id=5dfede0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfede0f"]])

export default __exports__